module.exports = __webpack_public_path__ + "static/img/14000055.e8037674.png";